import { Withdraw } from '@core/models/withdraw.model';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { Injectable } from '@angular/core';

@Injectable()
export class WithdrawV2EntityService extends EntityCollectionServiceBase<Withdraw> {
  constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
    super('WithdrawV2', serviceElementsFactory);
  }
}
